var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDownFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.042,
    height: 6.479
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.369 6.184L.216 1.436A.866.866 0 01.868 0h8.307a.866.866 0 01.652 1.437L5.674 6.183a.866.866 0 01-1.3 0z",
    fill: "#6b7786"
  })));
}
export default __webpack_public_path__ + "static/media/caret-down-fill.aad9d2d3.svg";
export { SvgCaretDownFill as ReactComponent };